var indentStyle = {"indentZero":"MIiJ6","indentOne":"wKdK1","indentTwo":"_-39qZ","indentThree":"qWzEg","indentFour":"gBAMj","indentFive":"E7R8M","indentSix":"O5FGi"};

export { indentStyle as i };
//# sourceMappingURL=indentation-6591a40d.js.map
